import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { useMemo } from 'react';
import { EnhancedMarkdown } from '../../EnhancedMarkdown';
import { extractSourcesFromCitations } from './extractSources';
import { parseCitations } from './parseCitations';
import { SourcesSection } from './SourcesSection';
/**
 * Renders a text message part with markdown support and inline citations
 * NOTE: Not memoized - text streams in token-by-token, so memo would provide no benefit
 */ export function TextPart({ part, messageId, index, variant = 'default' }) {
    // Parse citations and extract sources
    const { citationMap } = useMemo(()=>parseCitations(part.text), [
        part.text
    ]);
    const sources = useMemo(()=>extractSourcesFromCitations(citationMap), [
        citationMap
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": Testids.assistant.messageText,
        children: [
            /*#__PURE__*/ _jsx(EnhancedMarkdown, {
                content: part.text,
                className: "prose-sm",
                density: variant === 'specra' ? 'chat' : 'default',
                enableCitations: true
            }),
            sources.length > 0 && /*#__PURE__*/ _jsx(SourcesSection, {
                documents: sources
            })
        ]
    }, `${messageId}-text-${index}`);
}
